import React from 'react';

const Privacy = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>Privacy Policy</h1>
      <div style={{ marginTop: '1rem' }}>
        <p>Last updated: June 3, 2025</p>

        <section style={{ marginTop: '2rem' }}>
          <h2>1. Information We Collect</h2>
          <p>
            We does not collect, store, or transmit any personal information. The extension operates entirely within your browser and does not require an account, login, or any personally identifiable information. All syllabus files and matched topic data are stored locally in your browser's storage and never leave your device.
          </p>
        </section>

        <section style={{ marginTop: '2rem' }}>
          <h2>2. How We Use Your Information</h2>
          <p>
            Since we processes all data locally, no user information is transmitted to any server. Uploaded syllabus data is only used to match webpage content with your chosen topics, enabling personalized learning overlays and AI-powered content explanations. This data remains on your device and can be cleared at any time through the extension settings.
          </p>
        </section>

        <section style={{ marginTop: '2rem' }}>
          <h2>3. Information Sharing and Security</h2>
          <p>
            We do not share any information with third parties. All processing is performed client-side, and the extension does not use or include any remote code. VizAI does not access your browsing history and only runs when actively enabled by the user. We apply best practices to ensure that all data processed within your browser remains secure and private.
          </p>
        </section>

        <section style={{ marginTop: '2rem' }}>
          <h2>4. Changes to This Policy</h2>
          <p>
            We may update this policy in the future to reflect changes in functionality or browser standards. Any updates will be posted here with a revised "Last Updated" date.
          </p>
        </section>

        <section style={{ marginTop: '2rem' }}>
          <h2>5. Contact Us</h2>
          <p>
            If you have any questions or concerns about this Privacy Policy or VisualizeAI's data practices, please contact us at: [alexison.pan[at]gmail[dot]com]
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
